import React from "react";
import CaretakersLayout from "../../components/organisms/caretakers-layout/caretakers-layout";
import SEO from "../../shared/components/atoms/seo/seo";
import { siteUrl } from '../../shared/utils/siteUrl';
import SingleModuleContent from "../organisms/single-module-content/single-module-content";


const SingleModuleTemplate = props => {

    return (
        <CaretakersLayout activeMenu={2}>
            <SEO
                title={props.pageContext.params.metaTitulo}
                description={props.pageContext.params.metaDescripcion.metaDescripcion}
                url={siteUrl + '/curso-de-cuidadores/modulos/' + props.pageContext.slug}
                image={props.pageContext.params.metaImagen && props.pageContext.params.metaImagen.file.url}
            />
            <SingleModuleContent contentInfo={props.pageContext.params} />
        </CaretakersLayout>
    )
}

export default SingleModuleTemplate